import logos from '../img/connection_manager/logos';

export const ConnectionManagerNetworkKeys = {
  PIGEON_HOLE: 'pigeon-hole',
  TRAY: 'tray',
};

export const ConnectionManagerNetworks = {
  [ConnectionManagerNetworkKeys.PIGEON_HOLE]: {
    id: ConnectionManagerNetworkKeys.PIGEON_HOLE,
    logo: logos.pigeonHoleLogo,
    title: 'Pigeonhole',
    description: '',
    type: ConnectionManagerNetworkKeys.PIGEON_HOLE,
    vendor: 'Pigeonhole',
    isSupported: true,
  },
};

export const DEFAULT_STREAM_DESCRIPTION = 'add description';
export const DEFAULT_CONNECTION_LIMIT = 1;

export const SUPPORT_LINK = {
  DOWNLOAD_MOBILE_APP: 'https://go.socialive.us/support-center/mobile-app-1',
  EXPORT_RECORDINGS_CLIPS: 'https://go.socialive.us/support-center/export-recordings-1',
  GREEN_ROOM_EXPERIENCE: 'https://go.socialive.us/support-center/green-room-1',
  KNOWLEDGE_CENTER: 'https://go.socialive.us/knowledge-center',
  PRODUCT_UPDATES: 'https://go.socialive.us/support-center/product-updates-1',
  SETTING_UP_PIGEONHOLE: 'https://go.socialive.us/support-center/pigeonhole-1',
  SUPPORT_CENTER: 'https://go.socialive.us/support-center',
};

export const MIN_PASSWORD_REQUIREMENTS_TEXT =
  'Password must be between 8 and 20 characters and contain a minimum of:\n\n1 number, 1 uppercase letter, 1 lowercase letter, 1 special character, and cannot contain any spaces.\n\nAllowed special characters: @#$%^&*+=!';

export const GUEST_LINK_EROR_MESSAGE = {
  FORBIDDEN: "Sorry, you don't have access to this broadcast",
  NOT_FOUND: 'Sorry, this broadcast is no longer available',
  DEFAULT: 'There was an error loading the broadcast, please try again.',
};

export const FILTER_STORAGE_KEY = {
  CHANNEL: 'filterByChannelPB',
  HOST: 'filterByHostPB',
};
export const DEFAULT_FILTER_OPTION = {
  CHANNEL: 'allChannels',
  HOST: { value: 'allHosts', label: 'Anyone' },
};
